module.exports = __webpack_public_path__ + "img/product_package.5cb78244.png";